var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 22.3399C4 17.9216 7.58172 14.3399 12 14.3399C16.4183 14.3399 20 17.9216 20 22.3399H18C18 19.0262 15.3137 16.3399 12 16.3399C8.68629 16.3399 6 19.0262 6 22.3399H4ZM12 13.3399C8.685 13.3399 6 10.6549 6 7.3399C6 4.0249 8.685 1.3399 12 1.3399C15.315 1.3399 18 4.0249 18 7.3399C18 10.6549 15.315 13.3399 12 13.3399ZM12 11.3399C14.21 11.3399 16 9.5499 16 7.3399C16 5.1299 14.21 3.3399 12 3.3399C9.79 3.3399 8 5.1299 8 7.3399C8 9.5499 9.79 11.3399 12 11.3399Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profile-icon.b33695aab3d7c0b0a062b70106c4cdef.svg";
export { ForwardRef as ReactComponent };